import { Navbar } from "@container/navbar";
import { Footer } from "@container/footer";
import { ReactNode } from "react";
import { SnackbarProvider } from "@hook/use-snackbar";

interface Props {
    children: ReactNode;
    isBeta?: boolean;
    showFooter?: boolean;
    hideNavbarMenu?: boolean;
    isHideLoginButton?: boolean;
    disableMinHeight?: boolean;
    cssRoot?: string
    cssMain?: string
    customLogo?: string;
    style?: React.CSSProperties;
}

export default function BasicLayout(props: Props) {
    return (
        <SnackbarProvider>
            <div className={`${props.disableMinHeight ? "" : "min-h-screen"} bg-white dark:bg-gray-950 flex flex-col pb-16 sm:pb-0 ${props.cssRoot ? props.cssRoot : ""}`} style={props.style}>
                <Navbar isHideLoginButton={props.isHideLoginButton} hideNavbarMenu={props.hideNavbarMenu} customLogo={props.customLogo} />
                <main className={`flex-1 flex items-center justify-center ${props.cssMain ? props.cssMain : ""}`}>
                    {props.children}
                </main>
                {props.showFooter && (
                    <Footer />
                )}
            </div>
        </SnackbarProvider>
    );
}

